module.exports = __webpack_public_path__ + "img/case6.cd88a3bb.svg";